import React, { useRef, useState } from 'react';
import { Player } from '../classes/Player';
import { Round } from '../classes/Round';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { Score } from '../classes/Score';
import { Stats } from '../classes/Stats';
import { RoundPhase } from '../constants/RoundPhase';
import { getBlackCardText } from '../utils/TextsUtils';

interface FaceUpCardInterface {
    gameId: string;
    statsId: number;
    roundBlackCards: RoundBlackCard[];
    criminal: Player;
    scoresMap: Map<number, number>;
    roundBlackCardIdx: number;
    isJudge: boolean;
}

function FaceUpCard({gameId, statsId, roundBlackCards, criminal, scoresMap, roundBlackCardIdx, isJudge}: FaceUpCardInterface) {
    const [isDragging, setIsDragging] = useState(false);
    let dragCounterRef = useRef(0);

    const allAllBlackCardsOpened = () => {
        for (let idx = 0; idx < roundBlackCards.length; idx++) {
            if (roundBlackCards[idx].blackCardIdx !== -1 && !roundBlackCards[idx].isOpen) {
                return false;
            }
        }
        return true;
    }

    const handleChooseWinner = async (idx: number) => {
        if (idx < roundBlackCards.length) {
            const winnerId = roundBlackCards[idx].player;
            const newWinnerScore = scoresMap.get(winnerId) !== undefined ? scoresMap.get(winnerId)! + 1 : 1;
            await Score.updateScore(winnerId, newWinnerScore);
            
            const theWinnerBlackCardIdx = roundBlackCards[idx].blackCardIdx;
            Stats.updateWinnerCards(statsId, theWinnerBlackCardIdx);
            await Round.updateRoundWinner(gameId, RoundPhase.roundWinner, theWinnerBlackCardIdx, winnerId);
        }
    }

    const handleDragEnter = (event: any) => {
        event.preventDefault();
        dragCounterRef.current++;
        if (dragCounterRef.current === 1) {
            setIsDragging(true);
        }
    };

    const handleDragLeave = (event: any) => {
        event.preventDefault();
        dragCounterRef.current--;
        if (dragCounterRef.current === 0) {
            setIsDragging(false);
        }
    };

    const handleDragOver = (event: any) => {
        event.preventDefault();
    };

    const handleDrop = () => {
        if (allAllBlackCardsOpened()) {
            handleChooseWinner(roundBlackCardIdx);
        }
        setIsDragging(false);
    };

    const handleSelectWinnerCard = () => {
        if (isJudge && allAllBlackCardsOpened()) {
            handleChooseWinner(roundBlackCardIdx);
        }
    };

    return (
        <div className="faceUpCardWrapper"
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop()}
            style={{borderColor: `${isDragging ? "black": "#F2F2F2"}`}}
        >
            <div className="faceUpCardTextWrapper" style={{cursor: `${isJudge ? "pointer" : "default"}`}} tabIndex={isJudge ? 0 : -1} onClick={handleSelectWinnerCard}>
                <div className="faceUpCardText">
                    {getBlackCardText(roundBlackCards[roundBlackCardIdx].blackCardIdx, criminal.name, criminal.gender)}
                </div>
            </div>
        </div>
    );
};

export default FaceUpCard;